module.exports = __webpack_public_path__ + "img/Chasse.47e77a7b.png";